var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
Backbone.$ = $;
var Velocity = require('velocity-animate');

var imgSize = require('./utils/imgSize');

var breakpoints = {
    phoneP: 400,
    phoneH: 720,
    tabletP: 840,
    tabletH: 1080,
    desktop: 1280
}

var AppView = Backbone.View.extend({

    el: 'body',

    initialize: function(){
    	_.bindAll(this, 'resize');
        $(window).on('resize', this.resize);

        this.model = new Backbone.Model({
            landscape: false,
            touch: false
        });

        this.model.on({
            'change:landscape': this.landscapeToggle,
            'change:touch': this.touchToggle
        }, this);

        if('ontouchstart' in document.documentElement){
            this.model.set('touch', true);
        }
    },

    landscapeToggle: function(model, h){
        this.$el.toggleClass('isLandscape', h);
    },

    touchToggle: function(model, touch){
        this.$el.toggleClass('isTouch', touch);
    },

    render: function(){
    	this.resize();
    },

    resize: _.throttle(function(){
        this.w = $(window).width();
        this.h = $(window).height();

        this.model.set('landscape', this.h < this.w);

        var margin;

        if(this.w <= breakpoints.phoneP){
            margin = 15;
        } else if(this.w <= breakpoints.phoneH){
            margin = 55;
        } else if(this.w <= breakpoints.tabletP){
            margin = 60;
        } else if(this.w <= breakpoints.tabletH){
            margin = 120;
        } else {
            margin = 150;
        }

        var vMargin = margin;
        var narrow = false;
        if(margin <= 55 || this.h <= breakpoints.phoneP){
            vMargin = 55;
            narrow = true;
        }

        this.$el.toggleClass('narrow', narrow);
        
        var imageWidth = this.w - (margin * 2);
        var imageHeight = this.h - (vMargin * 2);

        var $img = this.$('#image');
        var dimensions = imgSize({
            $el: $img,
            imgW: parseInt($img.find('img').attr('width')),
            imgH: parseInt($img.find('img').attr('height')),
            width: imageWidth,
            maxHeight: imageHeight,
            midX: true,
            midY: true
        });

        this.$('header, footer').css({'height': (this.h - dimensions.height) / 2});

        var scale = 1;
        var textWidth = 1400;
        var textHeight = 540;

        var scaleX = this.w / textWidth;
        var scaleY = dimensions.height / textHeight;
        scale = Math.min(scaleX, scaleY, 1);

        Velocity.hook(this.$('#image .overlay'), 'scale', scale);
    }, 16),

});

module.exports = AppView;